module.exports = __webpack_public_path__ + "img/weixin.bbbea52c.jpg";